




















































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplateDashboard,
} from "@/configuration";
import ProjectStatus from "@/components/dashboard/ProjectStatus.vue";
import DatatableFilterPlugin from "@/filters";
// @ts-ignore
import JsonExcel from "vue-json-excel";
import API from "@/api";

Vue.component("downloadExcel", JsonExcel);
Vue.use(DatatableFilterPlugin);
@Component({
  metaInfo: {
    title: "Estado pagos",
    titleTemplate: TitleTemplateDashboard,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  computed: {
    ...mapState(["user"]),
    filteredDatatable() {
      return this.$data.newPayments.filter((i: any) =>
        Object.keys(this.$data.filters).every(
          (f) =>
            this.$data.filters[f].length < 0 ||
            this.$data.filters[f].includes(i[f])
        )
      );
    },
    filtered2() {
      return this.$data.newPayments.filter((i: any) => {
        return (
          this.$data.name.includes(i.proyecto.nombre) ||
          this.$data.id.includes(i.proyecto.id)
        );
      });
    },
  },
  data() {
    return {
      payments2: "",
      RedCapital,
      SelectedCountry,
      filters: {
        id: "2019-10",
        name: null,
        state: null,
      },
      id: "",
      name: "",
      state: "",
      canShow: false,
      showId: false,
      payments: null,
      newPayments: null,
      states: null,
      dialog: false,
      viewFees: false,
      /*feesHeaders: [
        {
          text: "Numero cuota",
          align: "center",
          sortable: false
        },
        {
          text: "Vencimiento Cuota",
          align: "center",
          sortable: false
        },
        {
          text: "Monto Cuota",
          align: "center",
          sortable: false
        },
        {
          text: "Monto pagado a la Fecha",
          align: "center",
          sortable: false
        },
        {
          text: "Estado cuota",
          align: "center",
          sortable: false
        }
      ],*/
      headers: [
        {
          text: "ID",
          align: "center",
        },
        {
          text: "Saldo Capital Inicio Período",
          align: "center",
        },
        {
          text: "Saldo Capital Final Período",
          align: "center",
        },
        {
          text: "Saldo Total Inicial",
          align: "center",
        },
        {
          text: "Pagos en el Mes",
          align: "center",
        },
        {
          text: "Capital Pagado",
          align: "center",
          sortable: false,
        },
        {
          text: "Interés Pagado",
          align: "center",
          sortable: false,
        },
        {
          text: "Interes Devengado",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  async beforeMount() {
    setTimeout(() => {
      this.$data.canShow = true;
    }, 1000);
    this.$data.newPayments = [
      {
        id: 3823,
        saldoI: "4.935.000",
        saldoF: "4.935.000",
        saldoT: "5.186.415",
        pagosMes: "",
        capitalP: "",
        interesP: "",
        interesD: "65.046",
      },
      {
        id: 5338,
        saldoI: "3.000.000",
        saldoF: "3.000.000",
        saldoT: "3.062.884",
        pagosMes: "",
        capitalP: "",
        interesP: "",
        interesD: "33.041",
      },
      {
        id: 5368,
        saldoI: "3.000.000",
        saldoF: "",
        saldoT: "3.050.571",
        pagosMes: "3.058.280",
        capitalP: "3.000.000",
        interesP: "58.280",
        interesD: "3.429",
      },
      {
        id: 5718,
        saldoI: "2.000.000",
        saldoF: "",
        saldoT: "2.013.866",
        pagosMes: "2.057.780",
        capitalP: "2.000.000",
        interesP: "57.780",
        interesD: "5.867",
      },
      {
        id: 5761,
        saldoI: "1.000.000",
        saldoF: "",
        saldoT: "1.006.723",
        pagosMes: "1.008.533",
        capitalP: "1.000.000",
        interesP: "8.533",
        interesD: "1.810",
      },
      {
        id: 5888,
        saldoI: "304.994",
        saldoF: "304.994",
        saldoT: "305.635",
        pagosMes: "",
        capitalP: "",
        interesP: "",
        interesD: "2.837",
      },
      {
        id: 6008,
        saldoI: "5.000.000",
        saldoF: "",
        saldoT: "5.000.000",
        pagosMes: "5.093.112",
        capitalP: "5.000.000",
        interesP: "93.112",
        interesD: "21.233",
      },
      {
        id: 6009,
        saldoI: "1.000.000",
        saldoF: "",
        saldoT: "1.000.000",
        pagosMes: "1.018.622",
        capitalP: "1.000.000",
        interesP: "18.622",
        interesD: "4.247",
      },
      {
        id: 6018,
        saldoI: "1.000.000",
        saldoF: "805.172",
        saldoT: "1.000.000",
        pagosMes: "207.928",
        capitalP: "194.828",
        interesP: "13.100",
        interesD: "12.590",
      },
      {
        id: 6432,
        saldoI: "4.098.479",
        saldoF: "4.098.479",
        saldoT: "4.098.479",
        pagosMes: "",
        capitalP: "",
        interesP: "",
        interesD: "",
      },
      {
        id: 6433,
        saldoI: "1.999.300",
        saldoF: "1.999.300",
        saldoT: "1.999.300",
        pagosMes: "",
        capitalP: "",
        interesP: "",
        interesD: "",
      },
      {
        id: "Total general",
        saldoI: "27.337.773",
        saldoF: "15.142.945",
        saldoT: "27.723.873",
        pagosMes: "12.444.255",
        capitalP: "12.194.828",
        interesP: "249.427",
        interesD: "150.100",
      },
    ];
    /*   API.getMyInvestments().then((payments: any) => {
      this.$data.payments = payments;
      API.getMyStates().then((states: any) => {
        this.$data.states = states;
        let arr = this.$data.payments.map((item: any, i: any) =>
          Object.assign({}, item, states[i])
        );
        this.$data.newPayments = arr;
        this.$data.filters.id = this.$data.newPayments
          .map((investment: any) => investment.proyecto.id)
          .filter((val: any) => val !== null);
        this.$data.filters.name = this.$data.newPayments
          .map((investment: any) => investment.proyecto.nombre)
          .filter((val: any) => val !== null);
        this.$data.canShow = true;
      });
      // this.$data.payments = (await API.getMyInvestments())
      // this.$data.canShow = true
    });*/
  },
  methods: {
    getInvestById(id: number) {
      if (this.$data.payments != null) {
        return this.$data.payments.find((el: any) => el.id == id);
      } else {
        return null;
      }
    },
    showFees(id: number) {
      this.$data.showId = id;
      this.$data.viewFees = true;
    },
    showComments(id: number) {
      this.$data.showId = id;
      this.$data.dialog = true;
    },
    fees() {
      if (this.$data.payments == null) {
        return [];
      }
      return this.$data.payments.find((el: any) => el.id == this.$data.showId)
        .inversionista_flujos; /* .filter((i: any) => i.flujo_inv > 0) */
    },
    resetFilters() {
      this.$data.id = "";
      this.$data.name = "";
      this.$data.state = "";
    },
    async refreshcartola() {
      setTimeout(() => {
        this.$data.canShow = true;
      }, 1000);
      this.$data.newPayments = [
        {
          id: 3823,
          saldoI: "4.935.000",
          saldoF: "4.935.000",
          saldoT: "5.186.415",
          pagosMes: "",
          capitalP: "",
          interesP: "",
          interesD: "65.046",
        },
        {
          id: 5338,
          saldoI: "3.000.000",
          saldoF: "3.000.000",
          saldoT: "3.062.884",
          pagosMes: "",
          capitalP: "",
          interesP: "",
          interesD: "33.041",
        },
        {
          id: 5368,
          saldoI: "3.000.000",
          saldoF: "",
          saldoT: "3.050.571",
          pagosMes: "3.058.280",
          capitalP: "3.000.000",
          interesP: "58.280",
          interesD: "3.429",
        },
        {
          id: 5718,
          saldoI: "2.000.000",
          saldoF: "",
          saldoT: "2.013.866",
          pagosMes: "2.057.780",
          capitalP: "2.000.000",
          interesP: "57.780",
          interesD: "5.867",
        },
        {
          id: 5761,
          saldoI: "1.000.000",
          saldoF: "",
          saldoT: "1.006.723",
          pagosMes: "1.008.533",
          capitalP: "1.000.000",
          interesP: "8.533",
          interesD: "1.810",
        },
        {
          id: 5888,
          saldoI: "304.994",
          saldoF: "304.994",
          saldoT: "305.635",
          pagosMes: "",
          capitalP: "",
          interesP: "",
          interesD: "2.837",
        },
        {
          id: 6008,
          saldoI: "5.000.000",
          saldoF: "",
          saldoT: "5.000.000",
          pagosMes: "5.093.112",
          capitalP: "5.000.000",
          interesP: "93.112",
          interesD: "21.233",
        },
        {
          id: 6009,
          saldoI: "1.000.000",
          saldoF: "",
          saldoT: "1.000.000",
          pagosMes: "1.018.622",
          capitalP: "1.000.000",
          interesP: "18.622",
          interesD: "4.247",
        },
        {
          id: 6018,
          saldoI: "1.000.000",
          saldoF: "805.172",
          saldoT: "1.000.000",
          pagosMes: "207.928",
          capitalP: "194.828",
          interesP: "13.100",
          interesD: "12.590",
        },
        {
          id: 6432,
          saldoI: "4.098.479",
          saldoF: "4.098.479",
          saldoT: "4.098.479",
          pagosMes: "",
          capitalP: "",
          interesP: "",
          interesD: "",
        },
        {
          id: 6433,
          saldoI: "1.999.300",
          saldoF: "1.999.300",
          saldoT: "1.999.300",
          pagosMes: "",
          capitalP: "",
          interesP: "",
          interesD: "",
        },
        {
          id: "Total general",
          saldoI: "27.337.773",
          saldoF: "15.142.945",
          saldoT: "27.723.873",
          pagosMes: "12.444.255",
          capitalP: "12.194.828",
          interesP: "249.427",
          interesD: "150.100",
        },
      ];
    },
  },
  components: {
    ProjectStatus,
  },
})
export default class CartolaMensual extends Vue {}
